import { FormSchema } from 'types/form-schema';
import useReferenceData from 'hooks/use-reference-data';

export default function useFormSchema(): FormSchema | undefined {
  const referenceData = useReferenceData();
  return referenceData?.formSchema;
}
